/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ArrayInput /* SelectWithSearch */ } from "@/components/form-input";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Portal } from "@/components/shared/portal";
// import JsonView from "@uiw/react-json-view";
import { useEffect } from "react";
import { TreeDetailsForm } from "../../../tree-details-form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const TreeDetailsStructure = ({
  setActiveRef,
  ref1,
  ref2,
  type,
  jsonData,
  onTreeChange,
  parentKey,
  defaultValue,
  onTreeFormSubmit,
  erp_mapping_value,
  erpListData,
  cardinality,
  orderTypeList,
  order_type,
  parentOrderType,
  entityCardinality,
  support_multi_doc_type,
  document_types,
  data_type,
}: // support_multi_doc_type,
// domainType,
any) => {
  useEffect(() => {
    setActiveRef({ ref1: ref1, ref2: ref2 });
    return () => {
      setActiveRef({ ref1: null, ref2: null });
    };
  }, []);

  return (
    <Portal id="tree-structure-details-node">
      <div ref={ref2} className="sticky top-5 h-fit text-sm">
        <div className="border  rounded-sm bg-gray-50">
          <div className="w-full text-left  grid grid-cols-2">
            <span className=" px-3 py-2  border-t-0 border-b-0 border-l-0 border">
              Type
            </span>
            <span className="px-3 py-2 text-slate-500">{type}</span>
          </div>
          <TreeDetailsForm
            defaultValue={defaultValue}
            type={type}
            erpListData={erpListData}
            onTreeFormSubmit={onTreeFormSubmit}
            erp_mapping_value={erp_mapping_value}
            orderTypeList={orderTypeList}
            order_type={order_type}
            parentOrderType={parentOrderType}
            entityCardinality={entityCardinality}
            support_multi_doc_type={support_multi_doc_type}
            document_types={document_types}
            parentKey={parentKey}
          />
          <ConditionRenderer condition={jsonData ? true : false}>
            <>
              <div className="w-full text-left  grid grid-cols-2 border border-l-0 border-r-0 border-b-0">
                <div className="px-3 py-2 border-t-0 border-b-0 border-l-0 border">
                  synonyms
                </div>
                <div className="p-0 text-slate-500 bg-white">
                  <ArrayInput
                    roundedDisabled={true}
                    value={jsonData?.synonyms}
                    placeholder="Add synonym"
                    onChange={(prop: string[]) =>
                      onTreeChange({ synonyms: prop, parentKey: parentKey })
                    }
                  />
                </div>
              </div>
              <div className="w-full text-left  grid grid-cols-2 border border-l-0 border-r-0 border-b-0">
                <div className="px-3 py-2 border-t-0 border-b-0 border-l-0 border">
                  cardinality
                </div>
                <div className="p-0 text-slate-500 bg-white">
                  <Select
                    value={"" + cardinality}
                    onValueChange={(prop) =>
                      onTreeChange({
                        synonyms: prop,
                        parentKey: parentKey.replace("synonyms", "cardinality"),
                      })
                    }
                  >
                    <SelectTrigger className="w-full rounded-none">
                      <>
                        <SelectValue placeholder="Select Cardinality" />
                      </>
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="1">1</SelectItem>
                      <SelectItem value="n">N</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="w-full text-left  grid grid-cols-2 border border-l-0 border-r-0 border-b-0">
                <div className="px-3 py-2 border-t-0 border-b-0 border-l-0 border">
                  Data Type
                </div>
                <div className="p-0 text-slate-500 bg-white">
                  <Select
                    value={"" + data_type}
                    onValueChange={(prop) =>
                      onTreeChange({
                        data_type: prop,
                        parentKey: parentKey.replace("synonyms", "data_type"),
                      })
                    }
                  >
                    <SelectTrigger className="w-full rounded-none">
                      <>
                        <SelectValue placeholder="Select Data Type" />
                      </>
                    </SelectTrigger>
                    <SelectContent>
                      {["string", "integer", "json", "datetime"].map((item) => {
                        return <SelectItem value={item}>{item}</SelectItem>;
                      })}
                    </SelectContent>
                  </Select>
                </div>
              </div>
              {/* {String(support_multi_doc_type)}
              {support_multi_doc_type ? (
                <div className="w-full text-left  grid grid-cols-2 border border-l-0 border-r-0 border-b-0">
                  <div className="px-3 py-2 border-t-0 border-b-0 border-l-0 border">
                    Document type
                  </div>
                  <div className="p-0 text-slate-500 bg-white">
                    <Select
                      value={"" + cardinality}
                      onValueChange={(prop) =>
                        onTreeChange({
                          synonyms: prop,
                          parentKey: parentKey.replace(
                            "synonyms",
                            "document_type"
                          ),
                        })
                      }
                    >
                      <SelectTrigger className="w-full rounded-none">
                        <>
                          <SelectValue placeholder="Select Cardinality" />
                        </>
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="1">1</SelectItem>
                        <SelectItem value="n">N</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              ) : null} */}
            </>
          </ConditionRenderer>
          <ConditionRenderer
            condition={type === "entity" && support_multi_doc_type}
          >
            <div className="w-full text-left grid grid-cols-2 border items-center">
              <div className="capitalize pl-3">Entity Types</div>
              <div>
                <>
                  <Select
                    value={document_types}
                    onValueChange={(prop) =>
                      onTreeChange({
                        document_types: prop,
                        parentKey: parentKey.replace(
                          "synonyms",
                          "document_types"
                        ),
                      })
                    }
                  >
                    <SelectTrigger className="w-full rounded-none">
                      <>
                        <SelectValue placeholder="Select Cardinality" />
                      </>
                    </SelectTrigger>
                    <SelectContent>
                      {[
                        "daily_sales_report",
                        "bank_deposit_slip",
                        "pos_payout_receipt",
                        "payout_invoice",
                      ].map((etItem) => {
                        return <SelectItem value={etItem}>{etItem}</SelectItem>;
                      })}
                      {/* <SelectItem value="n">N</SelectItem> */}
                    </SelectContent>
                  </Select>
                </>
              </div>
            </div>
          </ConditionRenderer>
        </div>
      </div>
    </Portal>
  );
};
